<template>
    <component
        :is="products"
        :brand="brand"
        :request-for-categories="requestForCategories"
        :is-category-page="isCategoryPage"
        :is-subdomain-brand-category-page="isSubdomainBrandCategoryPage"
        :is-subdomain-brand="isSubdomainBrand"
        @resetFilters="resetFilters"
    />
</template>

<script>
import { mapGetters } from 'vuex'

import ProductsPublic from '@/components/Public/Brand/Products/ProductsPublic'
import ProductsPublicRetailer from '@/components/Public/Brand/Products/ProductsPublicRetailer'

export default {
    name: 'PublicBrandProducts',

    components: {
        ProductsPublic,
        ProductsPublicRetailer
    },

    props: {
        brand: {
            type: Object,
            required: true
        },
        requestForCategories: {
            type: Boolean,
            required: false,
            default: false
        },
        isCategoryPage: {
            type: Boolean,
            required: false,
            default: false
        },
        isSubdomainBrandCategoryPage: {
            type: Boolean,
            required: false,
            default: false
        },
        isSubdomainBrand: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    computed: {
        ...mapGetters('user', ['isRetailer']),
        products() {
            return this.isRetailer && !this.isSubdomainBrand ? ProductsPublicRetailer : ProductsPublic
        }
    },

    methods: {
        resetFilters() {
            this.$emit('resetFilters')
        }
    }
}
</script>
